import clsx from 'clsx';
import React from 'react';

import ErrorDisplay from '../ErrorDisplay/ErrorDisplay';
import FieldWrapper from '../FieldWrapper/FieldWrapper';

const InputField = ({
  label = '',
  containerClassName = '',
  labelClassName = '',
  labelWidthClasses = '',
  registration = {},
  required = false,
  alphaNumeric = false,
  isAiGenerated = false,
  errorSettings = null,
  isManualExpensePrefilled = false,
  ...otherProps
}) => {
  const handleInput = (event) => {
    if (alphaNumeric) {
      const regex = /[^a-zA-Z0-9]/g;

      const newValue = event.target.value.replace(regex, '');
      event.target.value = newValue;
    }
  };

  return (
    <FieldWrapper
      label={label}
      required={required}
      labelClassName={labelClassName}
      labelWidthClasses={labelWidthClasses}
      containerClassName={clsx(containerClassName, errorSettings?.hasError && '!tw-items-baseline')}
    >
      <div className={clsx('inputInner--wrapper', 'tw-w-full')}>
        <input
          className={clsx(
            'tw-h-[32px] tw-w-full',
            'tw-border-solid tw-border-[1px]',
            'tw-rounded-[3px]',
            'tw-px-[12px] tw-py-[4px]',
            'tw-text-cfo-black',
            'placeholder:tw-text-cfo-grey-600 focus-visible:tw-outline-0',
            isAiGenerated ? '!tw-bg-[rgba(240,232,250,1)]' : '',
            isManualExpensePrefilled && otherProps?.value !== '' ? '!tw-bg-cfo-blue-200' : '',
            errorSettings?.hasError ? 'tw-border-cfo-red-400' : 'tw-border-cfo-grey-500'
          )}
          {...otherProps}
          {...registration}
          onInput={(event) => {
            handleInput(event);
            if (isManualExpensePrefilled) {
              (event.target as HTMLInputElement).classList.remove('!tw-bg-cfo-blue-200');
            }
          }}
        />

        {errorSettings?.hasError && <ErrorDisplay errorMessage={errorSettings?.content} />}
      </div>
    </FieldWrapper>
  );
};

export default InputField;
